export default [
  {id: 27, name: 'Алакуртти ', oktmo: '47608403101', geolocation: [66.962651, 30.344551]},
  {id: 27, name: 'Алакуртти ', oktmo: '47608403101', geolocation: [66.962651, 30.344551]},
  {id: 6, name: 'Апатиты', oktmo: '47519000001', geolocation: [67.567797, 33.406737]},
  {id: 13, name: 'Заозерск', oktmo: '47733000001', geolocation: [69.400373, 32.450139]},
  {id: 3, name: 'Заполярный', oktmo: '47515000002', geolocation: [69.413269, 30.79847]},
  {id: 2, name: 'Кандалакша', oktmo: '47608101001', geolocation: [67.156727, 32.414306]},
  {id: 7, name: 'Кировск', oktmo: '47522000001', geolocation: [67.615114, 33.663674]},
  {id: 5, name: 'Ковдор', oktmo: '47517000001', geolocation: [67.566195, 30.47416]},
  {id: 1, name: 'Кола', oktmo: '47605101001', geolocation: [68.878606, 33.026247]},
  {id: 8, name: 'Мончегорск', oktmo: '47524000001', geolocation: [67.938579, 32.935948]},
  {id: 4, name: 'Мурманск', oktmo: '47701000001', geolocation: [68.970663, 33.074918]},
  {id: 9, name: 'Оленегорск', oktmo: '47526000001', geolocation: [68.142161, 33.26696]},
  {id: 10, name: 'Полярные Зори', oktmo: '47528000001', geolocation: [67.372999, 32.497615]},
  {id: 14, name: 'Полярный', oktmo: '47737000005', geolocation: [69.19889, 33.450899]},
  {id: 11, name: 'Североморск', oktmo: '47730000001', geolocation: [69.076596, 33.417751]},
];
